import { AdminSidebar } from './AdminSidebar';

export const AdminLayout = ({ children }) => {
    return (
        <div className="min-h-screen bg-white">
            <AdminSidebar />
            <main className="ml-64 min-h-screen">
                {children}
            </main>
        </div>
    );
};

export default AdminLayout;
